import React, { FC } from 'react'
import { SellingPointsContent } from '@moonpig/web-shared-products'
import { useProductContext } from '../../../contexts/product'
import { ProductModule } from '../types'

export const ProductSellingPointsModule: FC<ProductModule> = ({ ...props }) => {
  const [{ product }] = useProductContext()

  return <SellingPointsContent product={product} {...props} />
}
